import * as i18n from '@formkit/i18n';
import * as icons from '@formkit/icons';
import * as themes from '@formkit/themes';

import { TailwindRACQTheme } from './tailwind.config';
import { createProPlugin, inputs } from '@formkit/pro';
import formkitSpinnerPlugin from '@/plugins/spinner/formkitSpinnerPlugin';
import formkitTooltipPlugin from '@/plugins/tooltip/formkitTooltipPlugin';
import formkitScrollToErrorsPlugin from '@/plugins/formkitScrollToErrorsPlugin';
import formkitDefaultPropsPlugin from '@/plugins/formkitDefaultPropsPlugin';
import formkitCurrencyInputPlugin from '@/plugins/formkitCurrencyInputPlugin';
import formkitHelpPlugin from '@/plugins/formkitHelpPlugin';
import formkitTrimAnswerPlugin from '@/plugins/formkitTrimAnswerPlugin';
import { confirmCaseInsensitivePlugin } from './plugins/confirmCaseInsensitivePlugin';
import { conditionalRequiredPlugin } from './plugins/conditionalRequiredPlugin';
import { routerLinkButton, linkButton } from '@/plugins/formkitLinkButton/formkitLinkButton';
import { createInput } from '@formkit/vue';
import { nativeRadio } from './inputs/nativeRadio';
import Toggle from '@/components/Toggle/Toggle.vue';
import SelectMenu from '@/components/SelectMenu/SelectMenu.vue';
import { findCarInput, findCarPlugin } from '@/plugins/findCar/findCarPlugin';
import formkitPreContentPlugin from './plugins/pre-post-contents/preContentPlugin';
import RadioCardList from '@/components/RadioCardList/RadioCardList.vue';
import RadioCardListExpandable from '@/components/RadioCardListExpandable/RadioCardListExpandable.vue';
import { racqFormKitIcons } from './assets/icons/racq-formkit-icons';

// Create a FormKit Pro licence key at https://pro.formkit.com/
const pro = createProPlugin('fk-847cc712eb', {
  nativeToggle: inputs.toggle,
  ...inputs,
});

const config = {
  plugins: [
    pro,
    formkitScrollToErrorsPlugin,
    formkitSpinnerPlugin,
    formkitTooltipPlugin,
    formkitHelpPlugin,
    formkitDefaultPropsPlugin,
    formkitCurrencyInputPlugin,
    findCarPlugin,
    formkitPreContentPlugin,
    confirmCaseInsensitivePlugin,
    conditionalRequiredPlugin,
    formkitTrimAnswerPlugin,
  ],
  locales: { en: i18n.en },
  locale: 'en',
  icons: { ...icons.genesisIcons, ...racqFormKitIcons },
  config: {
    // Generate FormKit themes and classes
    // Ref: https://formkit.com/essentials/styling#using-generateclasses-from-formkitthemes
    classes: themes.generateClasses(TailwindRACQTheme),
  },
  messages: {
    en: {
      validation: {
        required({ name }: any) {
          return `Please enter your ${name.toLowerCase()}`;
        },
      },
    },
  },
  inputs: {
    nativeRadio: nativeRadio,
    toggle: createInput(Toggle, {
      props: ['defaultOption', 'options'],
    }),
    findCar: findCarInput,
    routerLinkButton: routerLinkButton,
    linkButton: linkButton,
    racqDropdown: createInput(SelectMenu, {
      props: ['options'],
    }),
    radioCardList: createInput(RadioCardList, {
      props: ['options'],
    }),
    radioCardListExpandable: createInput(RadioCardListExpandable, {
      props: ['options'],
    }),
  },
};

export default config;
